import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import format from 'string-template';

class CodePromoBlocPartenaireComponent extends React.Component {
    renderPluralConditionnal(partner) {
        return partner.couponCount > 1 ? 's' : '';
    }

    render() {
        const { i18n, cssClassContainer, asOffers } = this.props;
        return (
            <div className={`${cssClassContainer ? cssClassContainer : ''} flex-container-v`}>
                {asOffers ? (
                    <p className="valeur">
                        {format(
                            i18n.COUPON_OFFERS,
                            this.props.partner.couponCount,
                            this.renderPluralConditionnal(this.props.partner)
                        )}
                    </p>
                ) : (
                    <p className="valeur">
                        {this.props.partner.couponCount} {i18n.code}
                        {this.renderPluralConditionnal(this.props.partner)}
                        <br />
                        {i18n.dereduction}
                    </p>
                )}
            </div>
        );
    }
}

CodePromoBlocPartenaireComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    cssClassContainer: PropTypes.string,
    // "x offre(s) promo" au lieu de "x codes de réduction"
    asOffers: PropTypes.bool
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18n: state.i18n.feature.partenaire
    };
};

export default connect(mapStateToProps)(CodePromoBlocPartenaireComponent);



// WEBPACK FOOTER //
// ./src/components/partner/CodePromoBlocPartenaireComponent.js